import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Bot,
  BarChart2,
  ClipboardList,
  Users,
  Settings,
  LogOut,
  MessageSquare,
  HelpCircle,
  Plug,
} from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';

export function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuthStore();

  const handleSignOut = async () => {
    await signOut();
    navigate('/auth');
  };

  const menuItems = [
    {
      icon: Bot,
      label: '1. Agent Builder',
      path: '/agent-builder',
      onboarding: 'nav-agent-builder',
    },
    {
      icon: Users,
      label: '2. Persona Builder',
      path: '/persona-builder',
      onboarding: 'nav-persona-builder',
    },
    {
      icon: ClipboardList,
      label: '3. Evaluator Builder',
      path: '/evaluator-builder',
      onboarding: 'nav-evaluator-builder',
    },
    {
      icon: MessageSquare,
      label: '4. Conversation Simulation',
      path: '/conversation-simulation',
      onboarding: 'nav-conversation-simulation',
    },
    {
      icon: BarChart2,
      label: '5. Evaluations',
      path: '/evaluations',
      onboarding: 'nav-evaluations',
    },
    {
      icon: Plug,
      label: 'Connections',
      path: '/connections',
      onboarding: 'nav-connections',
    },
    {
      icon: Settings,
      label: 'Settings',
      path: '/settings',
      onboarding: 'nav-settings',
    },
  ];

  return (
    <div className="flex w-64 flex-col border-r border-[#00000020] bg-prompt-safecomfantasy">
      {/* Logo and Title */}
      <div className="flex items-center gap-3 border-b border-[#00000020] p-4">
        <img
          src="/marque-full-colour-svg.svg"
          alt="PromptSafe"
          className="h-8 w-auto"
        />
        <div className="flex items-center gap-2">
          <span className="font-semibold text-prompt-safecomvulcan">
            PromptSafe&reg;
          </span>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                data-onboarding={item.onboarding}
                className={`flex items-center gap-3 rounded-lg px-4 py-2 transition-colors ${
                  location.pathname === item.path ||
                  location.pathname.startsWith(item.path + '/')
                    ? 'bg-prompt-safecomoutrageous-orange text-white'
                    : 'text-prompt-safecomabbey hover:bg-white hover:text-prompt-safecomvulcan'
                }`}
              >
                <item.icon className="h-5 w-5" />
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
          <li>
            <a
              href="https://www.prompt-safe.com/faq"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 rounded-lg px-4 py-2 text-prompt-safecomabbey transition-colors hover:bg-white hover:text-prompt-safecomvulcan"
            >
              <HelpCircle className="h-5 w-5" />
              <span>FAQ</span>
            </a>
          </li>
        </ul>
      </nav>

      {/* Email */}
      <div className="border-t border-[#00000020] p-4">
        <span className="text-sm text-prompt-safecomabbey">{user?.email}</span>
      </div>

      {/* Logout Button */}
      <div className="border-t border-[#00000020] p-4">
        <button
          onClick={handleSignOut}
          className="flex w-full items-center gap-3 rounded-lg px-4 py-2 text-left text-prompt-safecomabbey transition-colors hover:bg-white hover:text-prompt-safecomvulcan"
        >
          <LogOut className="h-5 w-5" />
          <span>Sign out</span>
        </button>
      </div>
    </div>
  );
}
